import { CommonModule } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-embedded-alert',
  templateUrl: './embedded-alert.component.html',
  styleUrls: ['./embedded-alert.component.css'],
  imports: [CommonModule],
})
export class EmbeddedAlertComponent implements OnInit {
  @Input() error!: string | null;
  @Input() success!: string | null;
  @Input() persistSuccess!: boolean | null;

  constructor() {}

  ngOnInit(): void {}

  onClose() {
    this.error = null;
    this.success = null;
  }
}
